<template>
  <div>
    <dx-tree-list
      ref="refDetailCostTreelist"
      :height='gridHeightTree'
      :data-source="productCostInfoDetail"
      :autoExpandAll='true'
      :show-borders="true" :showRowLines = 'true'
      :column-auto-width="true"
      column-resizing-mode="widget"
      :hover-state-enabled = "true"
      key-expr="seqId"
      parent-id-expr="parentSeqId"
      :selection="{ mode: 'single' }"
      :focused-row-enabled="true"
      :allow-column-resizing="true"
      @toolbar-preparing='onToolbarPreparing'
    >
      <DxColumn
        :allowEditing='false'
        data-field="품번"
        caption="품번"
      />
      <DxColumn
        :allowEditing='false'
        data-field="품명"
        caption="품명"
        width="180"
      />
      <DxColumn
        :allowEditing='true'
        caption="원단위"
        data-field="수량"
        :visible='true'
        format='#,##0.0000'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="소요량"
        data-field="소요량"
        :visible='true'
        format='#,##0.0000'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품목유형"
        data-field="품목유형"
        :visible='true'
      >
        <DxLookup
          :data-source="itemTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        caption="자재유형"
        data-field="자재유형"
      >
        <DxLookup
          :data-source="meterialTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        caption="공정유형"
        data-field="공정유형"
      >
        <DxLookup
          :data-source="processingTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        data-field="재질"
        caption="재질"
      />
      <DxColumn
        :allowEditing='false'
        caption="단위"
        data-field="단위"
        :visible='true'
      >
        <DxLookup
          :data-source="unitLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
          caption="재료비정보"
          alignment='center'
        >
          <DxColumn
            :allowEditing="true"
            caption="외주프레스품가격"
            data-field="외주프레스가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="코일가격"
            data-field="코일가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="스크랩가격"
            data-field="스크랩가격"
            :visible='true'
            dataType="number"
            format='#,##0.00'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="H/W가격"
            data-field="자재가격"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="재료비소계"
            data-field="재료비소계"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="(스크랩중량)"
            data-field="자사스크랩중량"
            :visible='true'
            dataType="number"
            format='#,##0.00000'
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="도급비용"
          data-field="도급비용"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="원가합계"
          :calculate-cell-value="calcCostSum"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
      <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <DxPaging :enabled="false"/>
    </dx-tree-list>
    <div style='height:0; overflow:hidden' class='float-left-hiden'>
      <dx-data-grid ref='refBomExportGrid'
        :data-source='mrpExcelExportInfo'
        height='300'
      >
        <DxExport
          :enabled="true"
          :file-name="excelFileName"
        />
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          width="80"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
        <DxColumn
        :allowEditing='true'
        caption="원단위"
        data-field="수량"
        :visible='true'
        format='#,##0.0000'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="소요량"
        data-field="소요량"
        :visible='true'
        format='#,##0.0000'
        dataType="number"
      >
      </DxColumn>
       <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          width='80'

        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
          width='120'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
          width='80'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          data-field="재질"
          caption="재질"
        />
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="재료비정보"
          alignment='center'
        >
          <DxColumn
            :allowEditing="true"
            caption="외주프레스품가격"
            data-field="외주프레스가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="코일가격"
            data-field="코일가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="스크랩가격"
            data-field="스크랩가격"
            :visible='true'
            dataType="number"
            format='#,##0.00'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="H/W가격"
            data-field="자재가격"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="재료비소계"
            data-field="재료비소계"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="(스크랩중량)"
            data-field="자사스크랩중량"
            :visible='true'
            dataType="number"
            format='#,##0.00000'
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="도급비용"
          data-field="도급비용"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="원가합계"
          data-field="원가합계"
          :calculate-cell-value="calcCostSum"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="재질"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0.0'
            summary-type="sum"
            column="외주프레스가격"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0.0'
            summary-type="sum"
            column="코일가격"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0.0'
            summary-type="sum"
            column="자재가격"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0.0'
            summary-type="sum"
            column="재료비소계"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0.0'
            summary-type="sum"
            column="도급비용"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0.0'
            summary-type="sum"
            column="원가합계"
            display-format="{0}"
          />
        </DxSummary>
      </dx-data-grid>
    </div>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import { DxTreeList, DxColumn, DxScrolling, DxPaging, DxLookup } from 'devextreme-vue/tree-list'
import DxDataGrid, { DxExport, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid'
export default {
  name: 'ProductMaterialCostDetailTemp',
  data: function () {
    return {
      gridHeightTree: null,
      productCostInfoDetail: null,
      itemTypeLookup: null,
      meterialTypeLookup: null,
      processingTypeLookup: null,
      unitLookup: null,
      excelFileName: null,
      mrpExcelExportInfo: []
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    baseDate: {
      type: String,
      default: null
    }
  },
  components: {
    DxTreeList,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxLookup,
    DxDataGrid,
    DxExport,
    DxSummary,
    DxTotalItem
  },
  created () {
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
  },
  mounted () {
    this.refreshCostDetail(this.item.key)
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcCostSum (row) {
      return (row.재료비소계 + row.도급비용)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '엑셀저장',
            icon: 'xlsfile',
            text: '엑셀저장',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              this.mrpExcelExportInfo = []
              const data = this.$refs.refDetailCostTreelist.instance.getDataSource()
              console.log(data._items)
              for (let i = 0; i < data._items.length; i++) {
                this.mrpExcelExportInfo.push(data._items[i].data)
              }
              setTimeout(() => {
                this.$refs.refBomExportGrid.instance.exportToExcel(false)
              }, 1000)
            }
          }
        }
      )
    },
    refreshCostDetail (goodsNo) {
      this.excelFileName = `${goodsNo}_재료비내역`
      this.$emit('refresh-detail-completed')
      this.$_sp.runNoEncodeFindProc('spFindAllMaterialCost', { 품번: goodsNo, 기준일: this.baseDate })
        .then((data) => {
          // this.$emit('refresh-detail-completed')
          this.productCostInfoDetail = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.dx-master-detail-cell {
  padding-top: 8px!important;
}
</style>
